import { Component, HostListener, OnInit } from '@angular/core';
import { DataService } from '../../../services/data.service';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-main-wrapper',
  templateUrl: './main-wrapper.component.html',
  styleUrls: ['./main-wrapper.component.scss'],
  standalone: false,
})
export class MainWrapperComponent implements OnInit {
  isLightTheme = false;
  isProfilePage;

  isMobile = window.innerWidth < 1023;

  isMarketPage = true;

  isMenuOpened = false;

  isLandingPage = false;
  public isAdminProject: boolean = false;
  public isProfileMenuOpened = false;

  constructor(
    public dataService: DataService,
    public router: Router
  ) {}

  navigateProfile(e, pageName: string) {
    e.stopPropagation();

    this.router.navigate([pageName]).then(() => {
      const container = document.querySelector('.mat-drawer-content');
      container?.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.isMobile = window.innerWidth < 1023;
  }

  ngOnInit(): void {
    // .afterClosed()
    // .subscribe({
    //   next: (data) => {
    //     this._geoService.checkIsKz().subscribe({
    //       next: (isKZ) => {
    //         if (isKZ) {
    //           this._dialog.open(GeoNotificationModalComponent);
    //         }
    //       },
    //       error: (e) => {
    //         console.error('GEO ERROR', e);
    //       },
    //     });
    //   },
    // });

    console.log('ROUTER URL', this.router.url, 'https://intebix.kz');
    this.isProfilePage = this.router.url.includes(`user-settings`);
    this.checkIfLandingPage(this.router.url);
    this.checkIfAdmin(this.router.url);

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.isProfilePage = this.router.url.includes(`user-settings`);
        this.checkIfLandingPage(event.urlAfterRedirects);
        this.checkIfAdmin(event.url);
      });

    this.dataService.getIsLightThemeEmitter().subscribe((data) => {
      this.isLightTheme = data;
    });
  }

  checkIfLandingPage(url: string): void {
    this.isLandingPage = url.includes('landing') || url === '/';
  }

  private checkIfAdmin(url: string): void {
    this.isAdminProject = url.includes('admin-intebix');
  }

  navigate(url: string) {
    if (url.includes('http')) {
      window.location.href = url;
    } else {
      this.router.navigate([url]);
    }
    this.isMenuOpened = false;
    this.isLandingPage = false;
  }

  closeMenu() {
    this.isMenuOpened = false;
  }

  profileMenuOpened(isProfileMenuOpened: boolean) {
    this.isProfileMenuOpened = isProfileMenuOpened;
  }
}
